import Axios from "axios";

export const blogAxios = Axios.create({
  baseURL: (global || window)._AUTHING__GLOBAL_CONFIG_?.blog?.apiHost,
});
